import TournamentsCard from './Card';
import { useTournaments } from '@/api/tournaments';
import { Section } from '@starsoft/common/components';
import { TournamentWithStats } from '@/models/tournament/with-stats';

import styles from './styles.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/lib/store';

export default function TournamentsPageContentCards() {
  const query = useSelector((state: RootState) => state.tournaments.query);
  const tab = useSelector((state: RootState) => state.tournaments.tab);
  const {
    isLoading,
    error,
    tournaments,
    refetch,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    data,
  } = useTournaments({
    limit: 20,
    query,
    status: tab,
  });

  return (
    <Section
      data={tournaments as TournamentWithStats[]}
      limit={10}
      paginated
      paginationType="manual"
      error={error}
      hasMore={hasNextPage}
      isLoading={isLoading}
      isLoadingMore={isFetchingNextPage}
      loadMore={fetchNextPage}
      refetch={refetch}
      className={`${styles.content} ${tournaments?.length == 0 ? styles['content--empty'] : ''}`}
      totalCount={data?.pages?.[0]?.metadata?.count}
      componenents={{
        component: (tournament, position) => (
          <TournamentsCard
            key={`tournament-card-${tournament?.id}`}
            position={position}
            item={tournament}
          />
        ),
        skeleton: index => (
          <TournamentsCard
            key={`tournament-card-skeleton-${index}`}
            position={index}
            item={{} as any}
            isLoading
          />
        ),
      }}
    />
  );
}
